<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-button @click.native="onClick" class="edit" type="info" size="sm" icon>
      <i class="text-white ni video-3"></i>
    </base-button>
    <modal :show.sync="modalform" >
      <h6  slot="header" class="modal-title">Meeting</h6>
      <h3 v-if="!link">Meeting link not found!</h3>
      <div v-else>
        <span>Direct url</span><br />
        <table><tr><td><a :href="link">{{link}}</a></td><td>
            <base-button
                        @click.native="onCopy(item)"
                        type="secondary"
                        outline
                        icon
                      >
                        <i class="text-black ni copy-2"></i>
                      </base-button>
            </td></tr></table>
        
        <br />
        <br />
        <br />
        <div class="text-center">
          <base-button type="primary" @click.native="onOpen">Join meeting</base-button>
        </div>
      </div>
      
    </modal>
  </div>
</template>

<script>
import { GetMeetingLink } from "../../services/classes";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Modal } from "@/components";
export default {
  components: {
    Modal,
    Loading
  },
  props: {
    id: String,
  },
  data() {
    return {
      isLoading: false,
      modalform: false,
      link: "",
    };
  },
  methods: {
    onClick() {
      this.isLoading = true;
      GetMeetingLink(this.id).then((response) => {
        this.isLoading = false;
        // if (response.data.result) {
          this.link = response.data.result;
          this.modalform = true;
        // } else {
        //   this.link = "";
        // }
      });
    },
    onOpen() {
      window.open(this.link, "_blank");
      this.modalform = false;
    },
    onCopy() {
      
      this.$copyText(this.link).then(
        (e) => {
          this.notifyVue("success", "Copied");
        },
        (e) => {
          this.notifyVue("danger", "Can not copy");
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
</style>